import type { KnowledgeArticleTranslations } from './articles.types';

export const KNOWLEDGE_BASE_ARTICLES_AR: KnowledgeArticleTranslations = {
  dashboard: {
    title: 'لوحة التحكم',
    content:
      'تعرض لوحة التحكم مقاييس إدارة النفايات الفورية والتاريخية لمنظمتك. استخدم التبويبات والرسوم البيانية والخرائط لمتابعة الأداء.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'dashboard-overview': {
    title: 'نظرة عامة على لوحة التحكم',
    content:
      '1. من القائمة الجانبية، افتح «لوحة التحكم» (أيقونة الرئيسية).\n\n2. اختر منظمتك من القائمة الجانبية.\n\n3. استخدم تبويبي «شهري» و«نظرة عامة على المنظمة» للتبديل بين العرض الشهري والإجمالي.\n\n4. استخدم أزرار الرأس لضبط حدود مؤشرات الأداء أو تخصيص المقاييس الظاهرة.\n\nنصيحة: إذا لم تظهر بيانات، تأكد من اختيار المنظمة الصحيحة ووجود بيانات تشغيلية للشهر المحدد.',
  },
  'dashboard-monthly-tab': {
    title: 'التبويب الشهري',
    content:
      '1. في لوحة التحكم، افتح تبويب «شهري».\n\n2. اختر الشهر من منتقي الأشهر.\n\n3. راجع بطاقات الإحصائيات مع مؤشرات الاتجاه مقارنة بالفترة السابقة.\n\n4. مرّر للأسفل لعرض الرسوم البيانية لكل مقياس محدد.\n\n5. عند تفعيل حدود مؤشرات الأداء، راجع قسم تقدم KPI في أعلى العرض الشهري.',
  },
  'dashboard-organization-overview': {
    title: 'نظرة عامة على المنظمة',
    content:
      '1. في لوحة التحكم، افتح تبويب «نظرة عامة على المنظمة».\n\n2. راجع مقاييس الأداء الإجمالية المجمّعة عبر كل البيانات المتاحة.\n\n3. تعرض البطاقات الإجماليات دون أسهم اتجاه شهرية.\n\n4. تتبع الرسوم والعناصر ما اخترته لهذا التبويب في «تخصيص لوحة التحكم».\n\nنصيحة: استخدم هذا التبويب للحصول على صورة عامة للأداء طويل المدى.',
  },
  'customize-dashboard': {
    title: 'تخصيص لوحة التحكم',
    content:
      '1. في لوحة التحكم، انقر «تخصيص لوحة التحكم». النافذة تتبع التبويب المفتوح (الشهري أو نظرة عامة على المنظمة).\n\n2. ابحث أو تصفّح كل العناصر المتاحة لنوع منظمتك — بما فيها تقدم KPI والخرائط والإحصائيات التشغيلية.\n\n3. حدّد العناصر التي تريد عرضها.\n\n4. انقر «حفظ التغييرات». يُحفظ اختيارك لكل تبويب في هذه الجلسة.\n\nنصيحة: إذا كانت منطقة الرسم أو الخريطة فارغة، افتح التخصيص في ذلك التبويب وأضف العناصر المطلوبة.',
  },
  'kpi-limits': {
    title: 'حدود مؤشرات الأداء (KPI)',
    summary: 'عيّن الأهداف وتابع التقدم في تبويب لوحة التحكم الشهري.',
    content:
      '1. افتح «لوحة التحكم» من القائمة الجانبية.\n\n2. انقر «حدود مؤشرات الأداء» في رأس لوحة التحكم.\n\n3. في النافذة، اختر مقياساً وعامل مقارنة وقيمة هدف، ثم أضف رسالة تنبيه.\n\n4. انقر «إضافة حد»، ويمكنك تفعيل أو تعطيل الحدود بالمفتاح.\n\n5. أغلق النافذة. تظهر مؤشرات الأداء المفعّلة كبطاقات تقدم في التبويب الشهري.\n\nنصيحة: استخدم «الذهاب إلى حدود مؤشرات الأداء» من هذا المقال لجولة قصيرة: أولاً اضغط الزر، ثم عبّئ النموذج.',
  },
  'download-report': {
    title: 'تنزيل التقرير',
    content:
      '1. افتح «التقرير» من الشريط الجانبي.\n\n2. اختر فترة التقرير من القائمة المنسدلة — شهر محدد أو «كل الأوقات».\n\n3. اضغط «تخصيص التقرير» لاختيار الأقسام التي تظهر في ملف PDF، ثم احفظ.\n\n4. انقر «تنزيل التقرير» وانتظر إنشاء ملف PDF.\n\n5. احفظ الملف من المتصفح.\n\nيتضمن التقرير الأقسام التي اخترتها، مثل جداول المقاييس وتفاصيل النفايات ومقارنات أهداف KPI عند تفعيل الحدود.',
  },
  'dashboard-maps': {
    title: 'خرائط لوحة التحكم',
    content:
      'في التبويب الشهري، مرّر أسفل الرسوم البيانية للوصول إلى الخرائط الحية عند توفر البيانات.\n\n• خريطة الحاويات — تعرض مواقع الحاويات للمنظمات التي لديها بيانات حاويات.\n• خريطة الشاحنات — تعرض مواقع الشاحنات النشطة لمنظمات الأسطول.\n\nانقر على العلامات لعرض تفاصيل الموقع. تتحدّث الخرائط عند تحميل بيانات لوحة التحكم للشهر المحدد.',
  },
  organizations: {
    title: 'المنظمات',
    content:
      'تعرض صفحة المنظمات السجلات التي يمكنك الوصول إليها. يستطيع المسؤولون إضافة المنظمات وتعديلها أو حذفها.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'organizations-overview': {
    title: 'نظرة عامة على المنظمات',
    content:
      '1. من القائمة الجانبية، افتح «المنظمات».\n\n2. راجع الجدول الذي يعرض اسم المنظمة ونوعها وبيانات التواصل.\n\n3. استخدم منتقي المنظمة في الشريط الجانبي للتبديل دون مغادرة الصفحة.',
  },
  'manage-organization': {
    title: 'تعديل منظمة',
    content:
      '1. اذهب إلى «المنظمات».\n\n2. افتح قائمة الإجراءات على صف المنظمة التي تريد تحديثها.\n\n3. عدّل الاسم أو النوع (معيد تدوير، ناقل نفايات، أو منفذ نفايات) أو بيانات التواصل أو وسوم الصناعة أو رابط خرائط Google أو الملاحظات حسب الحاجة.\n\n4. احفظ التغييرات.\n\nنصيحة: استخدم منتقي المنظمة في الشريط الجانبي للتبديل قبل تعديل سجل منظمة أخرى. لتغيير الشعار، راجع «شعار المنظمة».',
  },
  'organization-logo': {
    title: 'شعار المنظمة',
    summary: 'ارفع أو حدّث شعار منظمتك.',
    content:
      '1. افتح «المنظمات» من القائمة الجانبية.\n\n2. اضغط «تعديل» على منظمتك لفتح نافذة التفاصيل.\n\n3. في قسم شعار المنظمة، اختر ملف صورة للرفع (أو استبدال الشعار الحالي).\n\n4. يمكنك إزالة الشعار اختيارياً إذا لم تعد بحاجة إليه.\n\n5. اضغط «تحديث» للحفظ. يظهر الشعار في قائمة المنظمات والعروض ذات الصلة بعد الحفظ.\n\nنصيحة: استخدم شعاراً واضحاً مربعاً أو أفقياً ليعرض جيداً في الشريط الجانبي والجداول.',
  },
  approvals: {
    title: 'الموافقات',
    summary: 'راجع وقرر بشأن طلبات الموافقة المعلقة لمنظمتك.',
    content:
      '1. افتح «الموافقات» من القائمة الجانبية.\n\n2. استخدم تبويب «الوارد» لرؤية الطلبات بانتظار القرار. تبويب «السجل» يعرض الطلبات المعتمدة والمرفوضة والملغاة.\n\n3. اضغط «مراجعة» على طلب لفتح التفاصيل — المبرر، مقدّم الطلب، خطوة سير العمل، والنشاط.\n\n4. إن كان لديك صلاحية الموافقة: اختر «اعتماد» أو «رفض». عند الرفض، اكتب سبباً واضحاً ليعرف مقدّم الطلب ماذا يغيّر.\n\n5. إذا قدّمت طلباً لا يزال معلقاً، يمكنك «إلغاء الطلب» من عرض التفاصيل.\n\n6. استخدم «تحديث» لإعادة تحميل القائمة بعد التغييرات.\n\nنصيحة: الموافقات مرتبطة بالمنظمة المحددة في الشريط الجانبي. تحتاج الصلاحيات المناسبة لاعتماد الطلبات أو تقديمها.',
  },
  notifications: {
    title: 'الإشعارات',
    content:
      'تُبقيك الإشعارات على اطلاع بنشاط المنصة. افتح «الإشعارات» من الشريط الجانبي لمراجعة العناصر غير المقروءة.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'notification-bell': {
    title: 'فتح الإشعارات',
    content:
      '1. انقر على «الإشعارات» في أسفل الشريط الجانبي.\n\n2. يعرض الشارة عدد الإشعارات غير المقروءة.\n\n3. مرّر في القائمة لقراءة التنبيهات الأخيرة لمنظمتك.\n\n4. انقر خارج القائمة أو اضغط Escape لإغلاقها.\n\nتُقيَد الإشعارات بالمنظمة المحددة في الشريط الجانبي.',
  },
  'mark-notifications-read': {
    title: 'تعليم الإشعارات كمقروءة',
    content:
      '1. افتح قائمة جرس الإشعارات.\n\n2. انقر على إشعار واحد لتعليمه كمقروء — يختفي من قائمة غير المقروء.\n\n3. استخدم «تعليم الكل كمقروء» لمسح جميع الإشعارات غير المقروءة دفعة واحدة.\n\n4. يتحدّث عداد الشارة فوراً بعد التعليم.',
  },
  'user-management': {
    title: 'إدارة المستخدمين',
    content:
      'تتيح صفحة المستخدمين للمسؤولين ومديري المنظمة عرض أعضاء الفريق وتعيين الأدوار والتحكم في الفروع والصلاحيات.\n\nاختر من الخيارات أدناه للتعليمات ومرجع الصلاحيات.',
  },
  'add-user': {
    title: 'إضافة مستخدم',
    summary: 'تسجيل عضو فريق جديد بالحساب وكلمة المرور والدور.',
    content:
      '1. افتح «المستخدمون» من القائمة الجانبية.\n\n2. اضغط «إضافة مستخدم» لفتح نموذج التسجيل.\n\n3. في الحساب، أدخل بريد الموظف ورقم هاتفه.\n\n4. في كلمة المرور، عيّن كلمة مرور لتسجيل الدخول وأكّدها.\n\n5. يمكنك تعبئة البيانات الشخصية اختيارياً للموارد البشرية والتقارير.\n\n6. في الدور والصلاحيات، اختر دوراً جاهزاً (مسؤول، مدير العمليات، موظف، أو قراءة فقط)، أو فعّل الصلاحيات المتقدمة. عيّن مواقع الجمع عند الحاجة.\n\n7. اضغط حفظ. يستطيع المستخدم الجديد تسجيل الدخول بالبريد وكلمة المرور اللذين عيّنتهما.\n\nنصيحة: بعد الحفظ، استخدم «إدارة الموظفين» لتعديل الأدوار أو المواقع لاحقاً. راجع «مرجع الصلاحيات» لمعرفة ما يمكن لكل دور الوصول إليه.',
  },
  'users-overview': {
    title: 'إدارة الموظفين',
    content:
      '1. افتح «المستخدمون» من القائمة الجانبية.\n\n2. استخدم البحث والفلاتر للعثور على الموظفين.\n\n3. انقر أيقونة التعديل لفتح صفحة الموظف: الحساب، مواقع الجمع، والدور والصلاحيات.\n\n4. اختر دوراً جاهزاً أو فعّل الصلاحيات المتقدمة.\n\n5. لمنافذ النفايات، عيّن مواقع الجمع — جميع المواقع تستخدم * في الصلاحيات.\n\n6. احفظ التغييرات. يجب على الموظف إعادة تسجيل الدخول لتطبيق الصلاحيات.\n\nنصيحة: استخدم «مرجع الصلاحيات» في بطاقة الدور والوصول.',
  },
  'permissions-handbook': {
    title: 'مرجع الصلاحيات',
    content:
      'يشرح هذا الدليل معنى كل صلاحية عند تعيين الأدوار أو استخدام الصلاحيات المتقدمة.\n\nصيغة الصلاحية: recyclee.{معرف_المنظمة}.{معرف_الموقع}.{الكيان}.{الإجراء}\n\n• جميع المواقع — يستخدم * كمعرف للموقع مع sites ["*"]\n• موقع واحد — معرف الموقع في مسار الصلاحية\n• مسؤول المنظمة — recyclee.{org}.* يمنح وصولاً كاملاً\n\nالإجراءات: قائمة، قراءة، إنشاء، كتابة، حذف، إدارة، تعيين، وغيرها.\n\nالأدوار الجاهزة: مسؤول، مدير العمليات، موظف، قراءة فقط.\n\nللتفاصيل الكاملة لكل كيان، افتح مرجع الصلاحيات من صفحة تعديل المستخدم.',
  },
  'account-settings': {
    title: 'الحساب والتفضيلات',
    content:
      'افتح قائمة الحساب من ملفك الشخصي في أسفل الشريط الجانبي لتغيير لغة الواجهة، والتبديل بين الوضع الفاتح والداكن، وتسجيل الخروج. يعرض ملفك اسم المستخدم والمنظمة النشطة.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'change-language': {
    title: 'تغيير اللغة',
    content:
      '1. انقر على ملفك الشخصي في أسفل الشريط الجانبي لفتح قائمة الحساب.\n\n2. انقر «اللغات».\n\n3. اختر لغتك من القائمة: الإنجليزية، العربية، الأردية، الهندية، البنغالية، السنهالية، أو النيبالية.\n\n4. تتحدّث الواجهة فوراً، ويُحفظ اختيارك لتسجيل الدخول القادم.\n\nملاحظة: تعمل العربية والأردية على تحويل التخطيط تلقائياً إلى اتجاه من اليمين إلى اليسار (RTL) لقراءة مريحة. تتوفر الواجهة ومحتوى المساعدة بجميع اللغات المدعومة.',
  },
  'appearance-theme': {
    title: 'الوضع الفاتح والداكن',
    content:
      '1. انقر على ملفك الشخصي في أسفل الشريط الجانبي لفتح قائمة الحساب.\n\n2. استخدم مفتاح «الوضع الداكن» للتبديل بين المظهر الفاتح والداكن.\n\n3. يُحفظ تفضيلك تلقائياً ويُطبّق في كل زيارة.',
  },
  'branch-analysis': {
    title: "تحليل الفروع",
    summary: "قارن الأداء التشغيلي عبر الفروع لمنظمات منافذ النفايات.",
    content:
      "يعرض تحليل الفروع مقاييس الاستلام والنفايات والإيرادات والتحويل حسب موقع الجمع للشهر المحدد. متاح لمنظمات منافذ النفايات.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.",
  },
  'branch-analysis-overview': {
    title: "نظرة عامة على تحليل الفروع",
    summary: "افتح تحليل الفروع، اختر شهراً، وراجع بطاقات الملخص وبطاقات الفروع.",
    content:
      "1. افتح «تحليل الفروع» من الشريط الجانبي (قسم النظرة العامة).\n\n2. اختر شهر التقرير من قائمة الفترة في رأس الصفحة.\n\n3. راجع بطاقات الملخص لطلبات الاستلام وإجمالي النفايات والنفايات المكتملة والإيرادات ومعدل التحويل.\n\n4. مرّر إلى بطاقات الفروع — كل بطاقة تعرض أداء موقع جمع واحد في الشهر المحدد.\n\nنصيحة: ترى فقط الفروع التي يتيحها دورك. قد تظهر النفايات غير المخصصة كبطاقة مستقلة عند امتلاك وصول كامل للمواقع.",
  },
  'compare-branches': {
    title: "مقارنة الفروع وتصدير PDF",
    summary: "اختر فروعاً للمقارنة جنباً إلى جنب ثم صدّر تقرير PDF.",
    content:
      "1. في تحليل الفروع، اضغط «مقارنة الفروع» في الرأس.\n\n2. اختر فرعين على الأقل (أو استخدم تحديد الكل)، ثم اضغط التالي.\n\n3. راجع الرسوم والجدول التفصيلي للشهر المحدد.\n\n4. اضغط «تصدير PDF» لتنزيل تقرير المقارنة، أو رجوع لتغيير الاختيار.\n\nنصيحة: استخدم «الذهاب إلى مقارنة الفروع» من هذا المقال لجولة قصيرة داخل نافذة المقارنة.",
  },
};
